/**
 * Personalize progress bar - runs only when this section is on the page.
 * Dispatches custom events for prev/next/step so the theme can handle navigation.
 */
(function () {
  const SECTION_SELECTOR = '.personalize-progress-bar-section';
  const BAR_SELECTOR = '.personalize-progress-bar';
  const PREV_SELECTOR = '[data-personalize-prev]';
  const NEXT_SELECTOR = '[data-personalize-next]';
  const STEP_SELECTOR = '[data-personalize-step]';

  function updateMobileSummary(root) {
    const scope = root || document;
    const progress = scope.querySelector('.personalize-progress-bar__list');
    const number = scope.querySelector('.personalize-progress-bar__number');
    const text = scope.querySelector('.personalize-progress-bar__text');
    if (!progress || !number) return;

    const stepItems = progress.querySelectorAll('li');
    const activeItems = progress.querySelectorAll('li.active');
    const activeSteps = activeItems.length;
    const totalSteps = stepItems.length;

    if (totalSteps > 0) {
      number.textContent = activeSteps + ' of ' + totalSteps;
    }

    if (!text || !activeItems.length) return;

    const lastActive = activeItems[activeItems.length - 1];
    const container =
      lastActive.querySelector('.personalize-progress-bar__item-link, .personalize-progress-bar__item-inner') ||
      lastActive;
    const clone = container.cloneNode(true);
    const circleInClone = clone.querySelector('.personalize-progress-bar__circle');
    if (circleInClone) circleInClone.remove();
    text.textContent = clone.textContent.trim();
  }

  function init() {
    const section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    const bar = section.querySelector(BAR_SELECTOR);
    if (!bar) return;

    updateMobileSummary(section);

    const currentStep = parseInt(section.dataset.currentStep || '1', 10);
    const totalSteps = parseInt(section.dataset.totalSteps || '4', 10);

    // Prev buttons
    section.querySelectorAll(PREV_SELECTOR).forEach((btn) => {
      btn.addEventListener('click', () => {
        bar.dispatchEvent(
          new CustomEvent('personalize:prev', {
            bubbles: true,
            detail: { currentStep, totalSteps }
          })
        );
      });
    });

    // Next buttons
    section.querySelectorAll(NEXT_SELECTOR).forEach((btn) => {
      btn.addEventListener('click', () => {
        bar.dispatchEvent(
          new CustomEvent('personalize:next', {
            bubbles: true,
            detail: { currentStep, totalSteps }
          })
        );
      });
    });

    // Step number buttons (mobile)
    section.querySelectorAll(STEP_SELECTOR).forEach((btn) => {
      const step = parseInt(btn.dataset.personalizeStep, 10);
      if (isNaN(step)) return;
      btn.addEventListener('click', () => {
        bar.dispatchEvent(
          new CustomEvent('personalize:go', {
            bubbles: true,
            detail: { step, totalSteps }
          })
        );
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Shopify section is re-rendered (theme editor / sections)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector && e.target.querySelector(SECTION_SELECTOR)) {
      init();
    }
  });
})();
